import React from "react";

export function BrandMark({
  dark = false,
  withText = true,
  iconSize = 38,
  textSize = "text-lg",
  teluguSize = "text-sm",
}) {
  return (
    <div className="flex items-center gap-2.5">
      <img
        src="/avaginja-mark.png"
        alt="Avaginja"
        width={iconSize}
        height={iconSize}
        style={{ width: iconSize, height: iconSize }}
        className="rounded-full shrink-0"
      />
      {withText && (
        <div className="leading-none">
          <div className={`font-heading font-extrabold tracking-tight ${textSize} ${dark ? "text-white" : "text-foreground"}`}>
            AVAGINJA
          </div>
          <div className={`font-telugu ${teluguSize} mt-0.5 ${dark ? "text-white/70" : "text-primary"}`}>
            ఆవగింజ
          </div>
        </div>
      )}
    </div>
  );
}
